// ── Trinidad & Tobago areas ─────────────────────────────────────────────────────
// Single source of truth for the "Area/Region" address dropdown used across the app.
//
// Note: Trinidad does not use "parishes" — that terminology is historical and
// specific to Tobago. Locally, property is searched by town/area grouped by region
// (as on sites like My Bunch of Keys and Terra Caribbean), so the options below are
// area/town names grouped by region, with Tobago as its own group.
//
// The underlying form field is still named `parish` in state/payloads to preserve
// the existing backend contract; only the label and options have changed.

export const TT_AREA_GROUPS = [
  {
    label: "North West",
    areas: [
      "Port of Spain", "Woodbrook", "St. Clair", "St. James", "Newtown", "Belmont",
      "St. Ann's", "Cascade", "Maraval", "Diego Martin", "Petit Valley", "Westmoorings",
      "Carenage", "Chaguaramas", "Cocorite", "Glencoe", "Point Cumana", "Morvant",
      "Laventille",
    ],
  },
  {
    label: "North East",
    areas: [
      "San Juan", "Barataria", "Aranguez", "El Socorro", "Curepe", "St. Augustine",
      "St. Joseph", "Valsayn", "Tacarigua", "Trincity", "Tunapuna", "Arouca",
      "D'Abadie", "Arima", "La Horquetta", "Piarco", "Santa Cruz", "Maracas Bay",
      "Blanchisseuse", "Sangre Grande", "Toco", "Matura", "Valencia", "Manzanilla",
    ],
  },
  {
    label: "Central",
    areas: [
      "Chaguanas", "Charlieville", "Cunupia", "Longdenville", "Couva", "Point Lisas",
      "Carapichaima", "Freeport", "California", "Claxton Bay", "Caroni", "Felicity",
      "Waterloo", "Preysal", "Tabaquite", "Talparo", "Gran Couva",
    ],
  },
  {
    label: "South West",
    areas: [
      "San Fernando", "Marabella", "Vistabella", "Gulf View", "La Romain", "Cocoyea",
      "Ste. Madeleine", "Pointe-a-Pierre", "Gasparillo", "Penal", "Debe", "Barrackpore",
      "Princes Town", "Siparia", "Fyzabad", "La Brea", "Point Fortin", "Cedros",
      "Erin", "Palo Seco", "Moruga", "South Oropouche",
    ],
  },
  {
    label: "South East",
    areas: [
      "Rio Claro", "Mayaro", "Guayaguayare", "Tableland", "Williamsville", "Biche",
    ],
  },
  {
    label: "Tobago",
    areas: [
      "Scarborough", "Crown Point", "Bon Accord", "Canaan", "Lowlands", "Bethel",
      "Signal Hill", "Black Rock", "Buccoo", "Mt. Irvine", "Plymouth", "Moriah",
      "Castara", "Parlatuvier", "Roxborough", "Speyside", "Charlotteville", "Bacolet",
      "Mt. St. George", "Goodwood",
    ],
  },
];

// Grouped options for a <select> that supports <optgroup> (see FormField).
// Shape: [{ label, options: [{ value, label }] }]
export const TT_AREA_OPTION_GROUPS = TT_AREA_GROUPS.map((group) => ({
  label: group.label,
  options: group.areas.map((area) => ({ value: area, label: area })),
}));

// Flat options list (leading placeholder), for selects without optgroup support.
export const TT_AREA_OPTIONS = [
  { value: "", label: "Select Area/Region" },
  ...TT_AREA_GROUPS.flatMap((group) =>
    group.areas.map((area) => ({ value: area, label: area }))
  ),
];

// Flat list of area name strings (no placeholder).
export const TT_AREA_NAMES = TT_AREA_GROUPS.flatMap((group) => group.areas);
